import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useReveal } from '../../hooks/useReveal';
import { Building2, Landmark, Rocket, RefreshCw, HandHeart, Home } from 'lucide-react';

const Sectors = () => {
  const { t } = useLanguage();
  const [ref, visible] = useReveal();

  const sectors = [
    { icon: Landmark, key: 's1' },
    { icon: Building2, key: 's2' },
    { icon: Rocket, key: 's3' },
    { icon: RefreshCw, key: 's4' },
    { icon: HandHeart, key: 's5' },
    { icon: Home, key: 's6' },
  ];

  return (
    <section id="sectors" ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0A1628]">{t('sectors.title')}</h2>
          <div className="w-16 h-1 bg-[#00B4D8] mx-auto mt-6 rounded-full" />
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          {sectors.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} data-testid={`sector-${i}`}
                className={`flex items-center gap-3 bg-[#F8FAFC] border border-slate-100 rounded-full px-6 py-3 hover:border-[#00B4D8]/30 transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                style={{ transitionDelay: visible ? `${100 + i * 60}ms` : '0ms' }}>
                <Icon className="w-5 h-5 text-[#00B4D8]" />
                <span className="text-sm font-medium text-[#0A1628]">{t(`sectors.${s.key}`)}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Sectors;
